import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import moment from "moment";
import $ from "jquery";
import "daterangepicker/daterangepicker.css";
import "daterangepicker";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Writtenjathagamcount = () => {
  const today = moment().format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [paymentSummary, setPaymentSummary] = useState([]);
  const [search, setSearch] = useState("");
  const [filteredSummary, setFilteredSummary] = useState([]);

  useEffect(() => {
    fetchPaymentSummary();
  }, []);

  useEffect(() => {
    $("#dateRangePicker").daterangepicker(
      {
        startDate: moment(startDate),
        endDate: moment(endDate),
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
        },
      },
      (start, end) => {
        const newStart = start.format("YYYY-MM-DD");
        const newEnd = end.format("YYYY-MM-DD");
        setStartDate(newStart);
        setEndDate(newEnd);
        applyFilters(search, start, end);
        if (newStart === newEnd) {
          $("#dateRangePicker").html(start.format("MMMM D, YYYY"));
        } else {
          $("#dateRangePicker").html(`${start.format("MMMM D, YYYY")} - ${end.format("MMMM D, YYYY")}`);
        }
      }
    );
    $("#dateRangePicker").html(moment(today).format("MMMM D, YYYY"));
  }, []);

  useEffect(() => {
    applyFilters(search, moment(startDate), moment(endDate));
  }, [paymentSummary, search, startDate, endDate]);

  const fetchPaymentSummary = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/get_payment_summary`);
      setPaymentSummary(response.data);
      setFilteredSummary(response.data);
    } catch (error) {
      console.error("Error fetching payment summary", error);
    }
  };

  const applyFilters = (searchText, start, end) => {
    const filteredData = paymentSummary.filter((summary) => {
      if (!summary.TXN_DATE) return false;
      const txnDate = moment(summary.TXN_DATE, "DD/MM/YYYY");
      return txnDate.isBetween(start, end, undefined, "[]") && summary.TXN_DATE.includes(searchText);
    });
    setFilteredSummary(filteredData);
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    applyFilters(e.target.value, moment(startDate), moment(endDate));
  };

  // Calculate Total Count and Total Amount
  const totalCount = filteredSummary.reduce((acc, item) => acc + (item.transaction_count || 0), 0);
  const totalAmount = filteredSummary.reduce((acc, item) => acc + (parseFloat(item.total_amount) || 0), 0);

  const columns = [
    {
      name: "Transaction Date",
      selector: (row) => row.TXN_DATE,
      sortable: true,
    },
    {
      name: "Total Count",
      selector: (row) => row.transaction_count,
      sortable: true,
    },
    {
      name: "Total Amount",
      selector: (row) => `₹${row.total_amount}`,
      sortable: true,
    },
  ];

  return (
    <div className="bg-gray-100 p-6">
      <div className="max-w-7xl mx-auto bg-white shadow-lg rounded-lg p-6">
        <h1 className="text-2xl font-semibold mb-4 text-blue-700 text-center">
          Jathagam Payment Summary
        </h1>
        <div className="mb-4 text-center">
          <label className="mr-3 font-bold">Filter by Date:</label>
          <div id="dateRangePicker" className="inline-block p-2 border rounded cursor-pointer">
            {startDate === endDate
              ? moment(startDate).format("MMMM D, YYYY")
              : `${moment(startDate).format("MMMM D, YYYY")} - ${moment(endDate).format("MMMM D, YYYY")}`}
          </div>
        </div>
        <DataTable
          columns={columns}
          data={filteredSummary}
          pagination
          highlightOnHover
          striped
          persistTableHead
        />
        {/* Display Total Row */}
        <div className="flex justify-between border-t border-gray-300 py-3 font-semibold text-lg mt-4">
          <span>Total:</span>
          <span>{totalCount} Transactions</span>
          <span>₹{totalAmount.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};

export default Writtenjathagamcount;